import classNames from 'classnames';

const CalorieConscious = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 80 80"
    className={classNames('dietary-tag', className)}
  >
    <title>Calorie Conscious</title>
    <g id="heart">
      <path
        className="dietary-tag__heart"
        d="M57.31,7.39a18.18,18.18,0,0,0-13,5.25A19,19,0,0,0,40,19.4a19,19,0,0,0-4.3-6.76,18.18,18.18,0,0,0-13-5.25c-9.87,0-20.36,7.51-20.36,21.43C2.33,38.5,8.61,48.89,21,59.69a124.21,124.21,0,0,0,18.29,13.2l.73.41.73-.41A124.21,124.21,0,0,0,59,59.69C71.39,48.89,77.67,38.5,77.67,28.82c0-13.92-10.49-21.43-20.36-21.43"
      />
    </g>
  </svg>
);

CalorieConscious.propTypes = {
  className: PropTypes.string,
};

CalorieConscious.defaultProps = {
  className: '',
};

export default CalorieConscious;
